import React from "react";

type Props = {
    title: string;
    onChangeTitle: (value: string) => void;
    content: string;
    onChangeContent: (value: string) => void;
};

export default class TitleAndContentTextInput extends React.Component<Props> {
    render(): React.ReactNode {
        const { title, onChangeTitle, content, onChangeContent } = this.props;

        return (
            <>
                {/* Title Text Input */}
                <div>
                    <label className="block text-white font-medium mb-2">
                        Judul Reminder
                    </label>
                    <input
                        type="text"
                        className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Enter title"
                        onChange={(e) => onChangeTitle(e.target.value)}
                        value={title}
                    />
                </div>

                {/* Content Text Input */}
                <div>
                    <label className="block text-white font-medium mb-2">
                        Isi Reminder
                    </label>
                    <textarea
                        className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        rows={6}
                        placeholder="Enter content"
                        onChange={(e) => onChangeContent(e.target.value)}
                        value={content}
                    />
                </div>
            </>
        );
    }
}
